import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { BaseLayoutFactory } from '../../../components/base-layout-factory';
import { SubmissionSendProvider } from './context/submission-send-context';
import { SubmissionSendComponent } from './submission-send-component';

export function SubmissionSendFactory() {
    return (
        <BaseLayoutFactory>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <SubmissionSendProvider>
                    <SubmissionSendComponent />
                </SubmissionSendProvider>
            </LocalizationProvider>
        </BaseLayoutFactory>
    );
}
